const KEY = 'lastSelectedTopic';

export const updateLastSelectedTopic = (topicId: string) => {
    localStorage.setItem(KEY, topicId);
};

export const getLastSelectedTopic = (): string | null => {
    return localStorage.getItem(KEY) || null;
};
